import { render, staticRenderFns } from "./consulta_articulos_por_proveedor.vue?vue&type=template&id=380c7453&"
import script from "./consulta_articulos_por_proveedor.vue?vue&type=script&lang=js&"
export * from "./consulta_articulos_por_proveedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports